import { bind } from 'decko';
import { css } from 'emotion';
import { observer } from 'mobx-react';
import * as React from 'react';

// import addOnImage from '../assets/addOn/add-on-image.png';
import checked from '../assets/addOn/checked.svg';

import { BREAKPOINT_LARGE, BREAKPOINT_SMALL } from '../consts/breakpoints';
import { priceFormatter } from '../utils/priceFormatter';

// #region Style
const wrapper = css`
  margin: 0px 8px 0px 8px;
  padding: 20px 0 20px 0;
  height: 100%;
  cursor: pointer;
  @media (min-width: ${BREAKPOINT_SMALL}) {
    margin: 0px 20px 0px 20px;
  }
`;

const container = css`
  border-radius: 10px;
  height: 100%;
  box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;

  @media (min-width: 970px) {
    box-shadow: 1px 1px 20px 1px rgba(0, 0, 0, 0.16);
  }
`;

const imageContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  border-bottom: 2px solid #b7acd4;
  height: 300px;
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
`;

const image = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const contentContainer = css`
  padding: 15px 0 25px 20px;
`;

const select = css`
  display: flex;
  padding-right: 20px;
`;

const titleText = css`
  color: #414042;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: bold;
  @media (min-width: ${BREAKPOINT_LARGE}) {
    font-size: 24px;
  }
`;

const priceStyle = css`
  color: #72659f;
  padding-left: 52px;
  margin-top: 8px;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
  @media (min-width: ${BREAKPOINT_LARGE}) {
    font-size: 24px;
  }
`;

const description = css`
  margin: 21px 0 0px 0;
  padding-left: 52px;
  padding-right: 20px;
  color: #414042;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 14px;
  max-height: 200px;
  overflow: auto;
  @media (min-width: ${BREAKPOINT_LARGE}) {
    font-size: 16px;
  }
`;
// #endregion

interface IAddOnItemProps {
  title: string;
  price: number;
  currency: string;
  message: string;
  addOnImage: string;
  isSelected?: boolean;
  id: number;
  onClick?(id?: number): any;
}

@observer
export class AddOnItem extends React.Component<IAddOnItemProps> {
  public static defaultProps = {
    isSelected: false,
  };

  public render() {
    const { title, price, currency, message, addOnImage, isSelected } = this.props;

    return (
      <div className={wrapper}>
        <div className={container} onClick={this.onClick()} role="checkbox" aria-checked={isSelected}>
          <div className={imageContainer}>
            <img className={image} src={addOnImage} role="presentation" alt="" />
          </div>
          <div className={contentContainer}>
            <div className={select}>
              <div className={this.computeCheckboxStyle(isSelected)} />
              <div className={titleText}>{title}</div>
            </div>
            <div className={priceStyle}>{priceFormatter(Number(price), currency)}</div>
            <div className={description}>{message}</div>
          </div>
        </div>
      </div>
    );
  }

  @bind
  private onClick() {
    const { onClick, id } = this.props;

    return () => onClick && onClick(id);
  }

  private computeCheckboxStyle(isSelected?: boolean) {
    const backgroundImage = isSelected ? `url(${checked})` : 'none';
    const border = isSelected ? 'none' : 'solid 0.5px #9e9e9e';

    return css`
      box-sizing: border-box;
      width: 32px;
      height: 32px;
      min-width: 32px;
      min-height: 32px;
      margin: 7px 20px 0 0;
      border: ${border};
      background-color: #ffffff;
      background-image: ${backgroundImage};
      background-size: cover;
      border-radius: 50%;
    `;
  }
}
